import * as React from 'react';
import { SwapOutlined } from '@ant-design/icons';
import { Col, Input } from 'antd';
import { toDecimal } from '../../../utils/filter';
import Formatter from '../../../utils/formatter';
const InputGroup = Input.Group;

export default class Transform extends React.Component<any, any> {
    public static defaultProps = {
        size: 'default'
    };

    /**
     * change control
     * @param {0 | 1} index
     * @returns {(e: any) => void}
     */
    changeHandler = (index: 0 | 1) => (e: any) => {
        let { value = [], onChange, rate = 1, addon = [] } = this.props;
        const newVal = e.target.value.replace(/,/g, '');
        if (value[index] === newVal) return;
        if (newVal !== '') {
            const filter_base = toDecimal(Formatter.amount.getDps(addon[0]));
            const filter_target = toDecimal(Formatter.amount.getDps(addon[1]));
            if (index === 0) {
                const base = filter_base(newVal);
                value = [
                    base,
                    filter_target(Number(base).mul(rate))
                ];
            }
            if (index === 1) {
                const base = filter_target(newVal);
                value = [
                    filter_base(Number(base).mul(1 / rate)),
                    base
                ];
            }
        } else {
            value = [];
        }
        if (onChange) onChange(value);
    };

    /**
     * blur control
     */
    blurHandler = () => {
        const { value, onBlur } = this.props;
        onBlur && onBlur(value);
    };

    render() {
        const { addon, size, disabled, placeholder, rate, value = [] } = this.props;
        return (
            <InputGroup className={!!rate ? 'Currency Currency-input' : 'Currency'}>
                <Col span={11}>
                    <Input addonAfter={addon[0]} style={{ width: '100%' }}
                           placeholder={placeholder[0]} disabled={disabled} value={value[0]}
                           onBlur={this.blurHandler} onChange={this.changeHandler(0)} size={size}/>
                </Col>
                <Col span={2} className='Currency-addon'><SwapOutlined /></Col>
                <Col span={11} style={{ paddingRight: 0 }}>
                    <Input addonAfter={addon[1]} style={{ width: '100%' }}
                           placeholder={placeholder[1]} disabled={disabled} value={value[1]}
                           onBlur={this.blurHandler} onChange={this.changeHandler(1)} size={size}/>
                </Col>
            </InputGroup>
        );
    }
}
